module.exports = __webpack_public_path__ + "986a4ccf548dbb3eb63b5b9c2faa3638.png";